var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Loading'),_c('transition',{attrs:{"name":"fade"}},[(_vm.$route.params.windowRoute)?_c('Window',{attrs:{"window":_vm.$route.params.windowRoute,"param":_vm.$route.params.windowParam}}):_vm._e()],1),_c('Home',[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }